
export const CCConstants = {
  CAREGIVER: { name: 'caregiver', label: 'Caregiver' },
  COORDINATOR: { name: 'scheduler', label: 'Coordinator' },
  ADMIN: { name: 'admin', label: 'Admin' },
  SUSPENDED: { name: 'suspended', label: 'Suspended' },
  GRACE: { name: 'grace', label: 'Grace' },
  INVITED: { name: 'invited', label: 'Invited' },
  HRMANAGER: { name: 'hrmanager', label: 'HR Manager' },
  ELEARN: { name: 'elearn', label: 'eLearning' },
  SUPER_ADMIN: { name: 'super_admin', label: 'Super Admin' },
  CUSTOMER_SUPPORT: { name: 'customer_support', label: 'Customer Support' },
  RECRUITER: { name: 'recruiter', label: 'Recruiter' },
}

export const reportHelperTexts = {
  name: 'Give your report a name. It is displayed on CC Web Portal',
  published:
    'Only published reports are displayed in CC web portal. You can preview your dashboard here before publishing it',
  visibleForRoles: 'User roles that can view this report on CC web portal',
  visibleForSolution:
    'Report is displayed in CC web portal if agency has selected solution enabled',
  visibleForAgencies: 'Report is displayed only for selected agencies. Leaving this field empty will display the report for all agencies.',
  reportProvider: 'Select the report provider. This choice determines the source platform for your report.',
  reportId: 'Report Id is the unique identifier for your PowerBI report. Use the PowerBI service to find the correct Id. This Id is necessary to embed and display your PowerBI report in the CC web portal.',
}

export const secondaryStatusTypeEnums = [
  { value: '01', text: '01 - pending' },
  { value: '02', text: '02 - active' },
  { value: '03', text: '03 - hold' },
  { value: '04', text: '04 - terminated' },
  { value: '05', text: '05 - cancelled' },
]
export const complianceExclusionTypesEnums = [
  { value: 'oig', text: 'OIG' },
  { value: 'medicaid', text: 'Medicaid' },
  { value: 'sam', text: 'SAM' },
  { value: 'medchk', text: 'Medicheck' },
]

export const staffStatusDatabaseEnums = [
  { value: '01', label: '01 - Pending' },
  { value: '02', label: '02 - Active' },
  { value: '03', label: '03 - On Hold' },
  { value: '04', label: '04 - Terminated' },
  { value: '05', label: '05 - Cancelled' },
]

export const staffStatusDomainEnums = [
  { value: 'pending', label: '01 - Pending' },
  { value: 'active', label: '02 - Active' },
  { value: 'hold', label: '03 - On Hold' },
  { value: 'terminated', label: '04 - Terminated' },
  { value: 'cancelled', label: '05 - Cancelled' },
]

export const employeeTypeOptions = [
  { value: 'all', text: 'All' },
  { value: 'applicant', text: 'Applicant' },
  { value: 'caregiver', text: 'Caregiver' },
]

export const activeOptions = [
  { value: true, text: 'Yes' },
  { value: false, text: 'No' },
]

export const awsRegions = [
  { value: 'af-south-1', text: 'af-south-1' },
  { value: 'ap-east-1', text: 'ap-east-1' },
  { value: 'ap-northeast-1', text: 'ap-northeast-1' },
  { value: 'ap-northeast-2', text: 'ap-northeast-2' },
  { value: 'ap-northeast-3', text: 'ap-northeast-3' },
  { value: 'ap-south-1', text: 'ap-south-1' },
  { value: 'ap-south-2', text: 'ap-south-2' },
  { value: 'ap-southeast-1', text: 'ap-southeast-1' },
  { value: 'ap-southeast-2', text: 'ap-southeast-2' },
  { value: 'ap-southeast-3', text: 'ap-southeast-3' },
  { value: 'ap-southeast-4', text: 'ap-southeast-4' },
  { value: 'ca-central-1', text: 'ca-central-1' },
  { value: 'cn-north-1', text: 'cn-north-1' },
  { value: 'cn-northwest-1', text: 'cn-northwest-1' },
  { value: 'eu-central-1', text: 'eu-central-1' },
  { value: 'eu-central-2', text: 'eu-central-2' },
  { value: 'eu-north-1', text: 'eu-north-1' },
  { value: 'eu-south-1', text: 'eu-south-1' },
  { value: 'eu-south-2', text: 'eu-south-2' },
  { value: 'eu-west-1', text: 'eu-west-1' },
  { value: 'eu-west-2', text: 'eu-west-2' },
  { value: 'eu-west-3', text: 'eu-west-3' },
  { value: 'il-central-1', text: 'il-central-1' },
  { value: 'me-central-1', text: 'me-central-1' },
  { value: 'me-south-1', text: 'me-south-1' },
  { value: 'sa-east-1', text: 'sa-east-1' },
  { value: 'us-east-1', text: 'us-east-1' },
  { value: 'us-east-2', text: 'us-east-2' },
  { value: 'us-gov-east-1', text: 'us-gov-east-1' },
  { value: 'us-gov-west-1', text: 'us-gov-west-1' },
  { value: 'us-west-1', text: 'us-west-1' },
  { value: 'us-west-2', text: 'us-west-2' },
]

export const alayaCareRoleCategories = [
  { value: 'admin', text: 'Admin Portal Roles' },
  { value: 'office', text: 'Office Portal Roles' },
  { value: 'staff', text: 'Field Portal Roles' },
  { value: 'client', text: 'Client Portal Roles' },
]

export const SubscriptionStatus = {
  PENDING: 'PENDING',
  ACTIVE: 'ACTIVE',
  PENDING_CANCELLATION: 'PENDING_CANCELLATION',
  CANCELLED: 'CANCELLED',
}

export const AMS_INTEGRATIONS = {
  NONE: null,
  SAM: 'sam',
  HCP: 'hcp',
  HHAX: 'hhax',
  ARROW: 'arrow',
  VIVENTIUM: 'viventium',
  ALAYA: 'alaya',
  FUSE: 'fuse',
  HCM: 'hcm',
}

export const amsIntegrationOptions = [
  { value: AMS_INTEGRATIONS.NONE, text: 'None' },
  { value: AMS_INTEGRATIONS.SAM, text: 'SAM' },
  { value: AMS_INTEGRATIONS.HCP, text: 'HCP' },
  { value: AMS_INTEGRATIONS.HHAX, text: 'HHAX' },
  { value: AMS_INTEGRATIONS.ARROW, text: 'Arrow' },
  { value: AMS_INTEGRATIONS.VIVENTIUM, text: 'Viventium' },
  { value: AMS_INTEGRATIONS.ALAYA, text: 'AlayaCare' },
  { value: AMS_INTEGRATIONS.FUSE, text: 'Sandata Fuse' },
  { value: AMS_INTEGRATIONS.HCM, text: 'HCM Polaris' },
]

export const eventLogTypeGroups = {
  Caregiver: [
    'CAREGIVER_PROFILE_CREATED',
    'COMPLETE_CAREGIVER_PREHIRE',
    'CAREGIVER_PROFILE_UPDATED',
    'CAREGIVER_INVITATION_CREATED',
    'CAREGIVER_INVITATION_ACCEPTED',
    'CAREGIVER_EXTERNAL_ID_UPDATED',
    'CAREGIVER_COMPLIANCE_BLOCKS',
    'CAREGIVER_WORKHISTORY_UPDATE',
    'CAREGIVER_ABSENCE_CREATED',
    'CAREGIVER_ABSENCES_CREATED',
    'CAREGIVER_ABSENCE_UPDATED',
    'CAREGIVER_ABSENCE_REMOVED',
    'CAREGIVER_ABSENCES_REMOVED',
  ],
  Employee: [
    'EMPLOYEE_LOG_IN',
    'EMPLOYEE_LOG_OUT',
  ],
  Shift: [
    'CAREGIVER_SHIFT_OFFERED',
    'CAREGIVER_SHIFT_APPLIED',
    'CAREGIVER_SHIFT_UNAPPLIED',
    'CAREGIVER_SHIFT_ASSIGNED',
    'CAREGIVER_SHIFT_CANCELLED',
    'CAREGIVER_SHIFT_CANCEL_REQUESTED',
    'CAREGIVER_SHIFT_RESCHEDULED',
    'CAREGIVER_SHIFT_DECLINED',
    'CAREGIVER_SHIFT_REJECTED',
    'CAREGIVER_SHIFT_OFFER_READ',
    'CAREGIVER_SHIFT_OFFER_SENT',
    'SHIFT_EXTERNAL_ID_UPDATED',
    'CAREGIVER_SHIFT_REQUEST_RESTORED',
    'SHIFT_NOTE_UPDATED',
  ],
  Client: [
    'CLIENT_PROFILE_CREATED',
    'CLIENT_PROFILE_UPDATED',
    'CLIENT_NOTE_UPDATED',
  ],
  Others: [
    'BOT_EVENT_TRACKED',
    'APP_TRACKING_CAMPAIGN_UPDATE',
    'ABSENCE_TYPE_CREATED',
    'ABSENCE_TYPE_UPDATED',
  ],
}
